
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.995 0L0 4.362V12h12V4.362L5.995 0zm0 1.236l4.897 3.557-3.367 2.293L6 5.851 4.476 7.087 1.107 4.793l4.888-3.557zM1 5.929l2.664 1.815L1 9.903V5.929zM1.237 11L6 7.138 10.763 11H1.237zM11 9.903L8.335 7.744 11 5.93v3.974z"}})])
          )
        }
      }
    